"use client";

import { useSupabase } from "@/app/supabase-provider";
import { userOptions } from "@/hooks/queries/user/userOptions";
import { UserInfo } from "@/utils/types";
import { useQuery } from "@tanstack/react-query";
import { createContext, useContext } from "react";

type UserProviderContext = {
  user: UserInfo | null;
};

const Context = createContext<UserProviderContext | undefined>(undefined);

export default function UserProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user: authUser } = useSupabase();
  const { data: user } = useQuery(userOptions({ enabled: !!authUser }));

  return (
    <Context.Provider
      value={{
        user: user ?? null,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export const useUser = () => {
  const context = useContext(Context);
  if (context === undefined) {
    throw new Error("useUser must be used inside UserProvider");
  }
  return context;
};
